import { render } from "./Color.vue?vue&type=template&id=5ca13048&scoped=true"
import script from "./Color.vue?vue&type=script&lang=js"
export * from "./Color.vue?vue&type=script&lang=js"

import "./Color.vue?vue&type=style&index=0&id=5ca13048&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca13048"]])

export default __exports__